import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'rdf-block',
  templateUrl: './block.component.html',
  styleUrls: ['./block.component.css']
})
export class BlockComponent implements OnInit {
  @Input() block;
  @Input() blockNumberArray;
  @Input() blockPosition
  @Input() emittables
  @Output() onDeleteBlock = new EventEmitter()
  @Output() onMoveBlock = new EventEmitter()
  @Output() onSetBlockType = new EventEmitter()
  @Output() onSetSumTotals = new EventEmitter()
  constructor() { }

  ngOnInit() {
  }

  moveBlock(val) {
    this.onMoveBlock.emit(val)
  }

  deleteBlock() {
    this.onDeleteBlock.emit()
  }

  setSumTotals(sumTotals) {
    this.onSetSumTotals.emit(sumTotals)
  }

  setBlockType(blockType) {
    this.onSetBlockType.emit(blockType)
  }

}
